/* Páginas HerBalance v2 — generado por paginas-v2/construir_shopify.py. Interacciones compartidas (sin dependencias). */


/* ?ir=<id> o ?y=<px>: salta a esa posición al cargar (capturas y enlaces del visor). */
(() => {
  const q = new URLSearchParams(location.search);
  if (!q.has('ir') && !q.has('y')) return;
  document.documentElement.style.scrollBehavior = 'auto';
  const saltar = () => {
    const el = q.has('ir') && document.getElementById(q.get('ir'));
    window.scrollTo(0, el ? el.getBoundingClientRect().top + window.scrollY - 12 : Number(q.get('y')) || 0);
  };
  saltar();
  window.addEventListener('load', saltar);
})();

/* Barra fija de compra en celular: aparece cuando el botón principal sale de la pantalla por arriba.
   Se calcula con la posición en el evento de scroll (IntersectionObserver no avisa al saltar de abajo a arriba). */
(() => {
  const barra = document.querySelector('.barra-fija');
  const ancla = document.querySelector('[data-ancla-barra]');
  if (!barra || !ancla) return;
  document.body.classList.add('con-barra');
  const fin = document.querySelector('[data-fin-barra]');
  let raf = 0;
  const pintar = () => {
    const pasó = ancla.getBoundingClientRect().bottom < 0;
    const llegó = fin && fin.getBoundingClientRect().top < window.innerHeight;
    barra.classList.toggle('visible', pasó && !llegó);
  };
  window.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(pintar); }, { passive: true });
  pintar();
})();

/* Indicadores de carruseles en celular: <ul data-carrusel="x"> + <div data-indicador="x"><span>…</span></div>. */
document.querySelectorAll('[data-carrusel]').forEach(cont => {
  const ind = document.querySelector(`[data-indicador="${cont.dataset.carrusel}"]`);
  if (!ind) return;
  const marcas = [...ind.children];
  const pintar = () => {
    const max = cont.scrollWidth - cont.clientWidth;
    const k = max > 0 ? Math.round((cont.scrollLeft / max) * (marcas.length - 1)) : 0;
    marcas.forEach((m, j) => m.classList.toggle('activo', k === j));
  };
  cont.addEventListener('scroll', pintar, { passive: true });
  pintar();
});

/* Enlaces de WhatsApp con mensaje: <a data-wa="Hola, …">. */
document.querySelectorAll('a[data-wa]').forEach(a => {
  a.href = 'https://wa.me/573114380133?text=' + encodeURIComponent(a.dataset.wa);
  a.target = '_blank';
  a.rel = 'noopener';
});

